import { SHORTHAND_INDEX } from "@app/utils";

export const getShorthand = (body) => {
  return Boolean(body.indexOf(SHORTHAND_INDEX) + 1);
}